import { usePathname } from 'next/navigation';

import { PAGES_TYPES } from 'constants/pagesTypes';
import { projectsCasesUrls } from 'constants/ProjectCases';
import { PERSONAL_PAGES_NAMES } from 'constants/personalCards';
import { CERTIFICATES_PAGES_NAMES } from 'constants/certificates';
import { RECOMMENDATION_LETTERS_PAGES_NAMES } from 'constants/recommendationLetters';

const personCardsUrls = Object.values(PERSONAL_PAGES_NAMES).map(
  name => `/${PAGES_TYPES.personCards}/${name}`,
);
const certificatesUrls = Object.values(CERTIFICATES_PAGES_NAMES).map(
  name => `/${PAGES_TYPES.certificates}/${name}`,
);
const recommendationLettersUrls = Object.values(RECOMMENDATION_LETTERS_PAGES_NAMES).map(
  name => `/${PAGES_TYPES.recommendLetters}/${name}`,
);
const policiesUrls = [
  PAGES_TYPES.personalDataPolicy,
  PAGES_TYPES.confidentialPolicy,
  PAGES_TYPES.cookiesPolicy,
].map(policyUrl => `/${policyUrl}`);

/**
 * Хук `useCustomLocations` определяет текущее состояние маршрута в приложении.
 *
 * Он возвращает объект с булевыми значениями, указывающими,
 * находитесь ли вы на одной из определенных страниц:
 * - `isRadioPage`: true, если текущий путь равен '/radio'.
 * - `isCulturalCodePages`: true, если текущий путь равен '/cultural-code'
 *   или '/cultural-code/20thcentury'.
 * - `isCulturalCodePage`: true, если текущий путь равен '/cultural-code'.
 * - `isShubinPage`: true, если текущий путь равен '/cultural-code/20thcentury'.
 * - `isPersonCardPage`: true, если текущий путь начинается с '/person'.
 * - `isPoliticsPages`: true, если текущий путь - одна из трёх страниц политик (конфиденциальности, куки, обработки данных).
 * - `isCertificatesPages`: true, если текущий путь - одна из страниц сертификатов.
 * - `isRecommendationLettersPages`: true, если текущий путь - одна из страниц рекомендательных писем.
 * - `isProjectsCasesPages`: true, если текущий путь - одна из страниц кейсов.
 */
export const useCustomLocations = () => {
  const pathname = usePathname();

  const isCulturalCode = pathname === '/cultural-code';
  const isShubin = pathname === '/cultural-code/20thcentury';

  return {
    isRadioPage: pathname === '/radio',
    isCulturalCodePages: isCulturalCode || isShubin,
    isCulturalCodePage: isCulturalCode,
    isShubinPage: isShubin,
    isPersonCardPage: personCardsUrls.includes(pathname),
    isPoliticsPages: policiesUrls.includes(pathname),
    isCertificatesPages: certificatesUrls.includes(pathname),
    isRecommendationLettersPages: recommendationLettersUrls.includes(pathname),
    isProjectsCasesPages: projectsCasesUrls.includes(pathname),
  };
};
